import React, { Suspense } from "react";
import {
  Box,
  Container,
  Divider,
  Fade,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import LazyLoad from "react-lazyload";
import balcone from "../../assets/1811Mobile/balcone.JPG";
import DividerContainer from "../UI/Divider/DividerContainer";
import CustomMobileLanding from "../../pages/YogaSpace/Components/CustomMobileLanding";
import SocialIcons from "../UI/IconsComponents/SocialIcons";
import PreLoader from "../UI/GalleryElements/ParallaxPreloadImage";
import { Trans } from "react-i18next";
import ReviewSection from "../../pages/ReviewSection/ReviewSection";
import FollowBox from "../../components/FollowUs/FollowUs";
import vassoio from "../../assets/1811Mobile/vassohi.jpg";
import LazyLoadVideo from "../../components/Video/LazyLoadVideo";
import { useInView } from "react-intersection-observer";
// Lazy loaded components
const LazySectionOneMobile = React.lazy(
  () => import("../../pages/SectionTwo/Mobile/SectionOneMobile")
);
const Footer = React.lazy(() => import("../../pages/Footer/Footer"));
const MobileScrollLayout = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  const { ref, inView } = useInView({
    threshold: 0,
  });

  return (
    <div style={{ maxWidth: "100%" }}>
      <Box sx={{ zIndex: 1000, width: "100%" }}>
        <PreLoader />
        <CustomMobileLanding />
      </Box>
      <LazyLoadVideo />
      <div ref={ref}>
        <Box
          sx={{
            position: "fixed",
            top: 0,
            zIndex: 1,
            width: "100%",
            height: "100vh",
            pointerEvents: "none",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <Fade in={inView} timeout={1000}>
            <Box sx={{ p: "0 30px 20px 0" }}>
              <SocialIcons isHome />
            </Box>
          </Fade>
          <DividerContainer height="100%" zIndex={1} paddingTop="0px" />
        </Box>
        <Container
          sx={{
            height: "17.5vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            p={4}
            maxWidth={isMobile ? undefined : "60vw"}
            fontSize={isMobile ? "16px" : "24px"}
            textAlign="center"
            fontStyle="italic"
            letterSpacing="0.6px"
            lineHeight={1.5}
            fontFamily="ivymode"
            fontWeight={300}
          >
            <Trans
              i18nKey="kitchenSectionText"
              components={{
                italic: <i />,
                bold: <b style={{ fontWeight: 500 }} />,
              }}
            />
          </Typography>
        </Container>
        <LazyLoad once offset={250}>
          <Stack direction="row" width="100vw">
            <img
              src={balcone}
              alt="Balcony"
              loading="lazy"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </Stack>
        </LazyLoad>
        <LazyLoad once offset={250}>
          <Suspense fallback={<div style={{ height: "10vh" }} />}>
            <LazySectionOneMobile />
          </Suspense>
        </LazyLoad>
        <LazyLoad once offset={250}>
          <Stack
            sx={{
              my: 4,

              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100vw",
                height: isMobile ? "30vh" : "auto",
              }}
            >
              <img
                src={vassoio}
                alt="Kitchen"
                loading="lazy"
                style={{
                  width: "90%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "bottom",
                }}
              />
            </Box>
            <Box
              sx={{
                width: "80%",
                paddingTop: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              {" "}
              <Typography
                variant="body1"
                textAlign="center"
                letterSpacing="0.7px"
                lineHeight={isMobile ? "22px" : "28px"}
                fontSize={"14px"}
              >
                <Trans
                  i18nKey="stendal"
                  components={{
                    bold: <b />,
                    italic: <i />,
                  }}
                />
              </Typography>
            </Box>
          </Stack>
        </LazyLoad>
        <ReviewSection />
        <Divider
          sx={{
            width: "30vw",
            mx: "auto",
          }}
        />
        <FollowBox />
      </div>
      <Suspense fallback={<div />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default MobileScrollLayout;
